/** Display names and units for the part categories (api/src/data/item_types.ts). */
export const CATEGORY_LABEL: Record<string, string> = {
  Frame: "Frames",
  Cover: "Covers",
  Base: "Bases",
  Fabric: "Fabric",
  Trim: "Trim",
  ProtectiveCover: "Protective covers",
};

/** Fabric and trim are bought and counted in yards. */
export const isYards = (type: string) => type === "Fabric" || type === "Trim";
